import schedule from './schedule/reducers';
import scale from './scale/reducers';

const data = {
  ...schedule,
  ...scale,
};

export default data;
